<template>
   <div class='currennt-bill' :class="{'flex-column':!showBillInfo}">
      <div class="current-bill-head">
         <!-- <h2 class="current-bill-month">当前账单({{billInfo.ts | formatDate('MM') | removeLeftZero}}月)</h2> -->
         <div class="bill-box">
            <div class="account-bill" @click="accountTab(1)">
               <!-- 已出账单 -->
               <div class="account-title" :class="[currentIndex==1?'active':'']">{{$t('bstext.bs35')}}</div>
               <div class="account-time" :class="[currentIndex==1?'active':'']" v-if="sta">({{sta | formatDate('MM/dd')}}-{{end | formatDate('MM/dd')}})</div>
               <!-- 暂无 -->
               <div class="account-time" :class="[currentIndex==1?'active':'']" v-else>({{$t('bstext.bs36')}})</div>
               <div class="account-line" :class="[currentIndex==1?'active-line':'']"></div>
            </div>
            <div class="no-account account-bill" @click="accountTab(2)">
               <!-- 未出账单 -->
               <div class="account-title" :class="[currentIndex==2?'active':'']">{{$t('bstext.bs37')}}</div>
               <!-- 至今 -->
               <div class="account-time" :class="[currentIndex==2?'active':'']" v-if="unsta">({{unsta | formatDate('MM/dd')}}-{{$t('bstext.bs38')}})</div>
               <!-- 暂无 -->
               <div class="account-time" :class="[currentIndex==2?'active':'']" v-else>({{$t('bstext.bs36')}})</div>
               <div class="account-line" :class="[currentIndex==2?'active-line':'']"></div>
            </div>
         </div>
         <div class="current-bill-price" v-if="showBillInfo">
            <!-- 最后付款日 -->
            <div class="current-bill-date" v-if="billInfo.status==payStatus.nonPaid&&currentIndex==1">{{billInfo.status | formatStatus(payStatuss)}}({{$t('bstext.bs41')}}:{{$d(billInfo.deadline*1000,'small')}})</div>
            <!-- 为保证正常使用，请尽快付款 -->
            <div class="current-bill-date" v-else-if="billInfo.status==payStatus.overdue&&currentIndex==1">{{billInfo.status | formatStatus(payStatuss)}}({{$t('bstext.bs42')}})</div>
            <!-- 未出账(出账日 -->
            <div class="current-bill-date" v-else-if="currentIndex==2">{{$t('bstext.bs39')}}({{$t('bstext.bs40')}}:{{$d(billInfo.ts*1000,'small')}})</div>
            <!-- <div class="current-bill-date" v-else-if="currentIndex==2">{{$t('bstext.bs39')}}({{$t('bstext.bs40')}}:{{billInfo.ts | formatDate('MM月dd日') }})</div> -->
            <div class="current-bill-account"><span>{{billInfo.currencySymbol}}</span>{{billInfo.amount | formatPrice}}</div>
         </div>
      </div>
      <div class="current-bill-body" v-if="showBillInfo">
         <div class="current-bill-box">
            <!-- 套餐费用 -->
            <h2 class="current-bill-cost"><span>{{$t('bstext.bs19')}}</span><span class="ml5">{{billInfo.currencySymbol}}{{billInfo.serviceAmount | formatPrice}}</span></h2>
            <div class="current-bill-content" v-for="(item,index) in billInfo.serviceInfo" :key="index">
               <!-- '单电套餐':'双电套餐' -->
               <p class="current-bill-name"><span>{{item.name}}{{item.battAmount==1?$t('bstext.bs20'):$t('bstext.bs21')}}</span><i class="ml5">{{billInfo.currencySymbol}}{{item.amount | formatPrice}}</i></p>
               <p class="current-bill-cycle">{{item.staTime | formatDate('yyyy.MM.dd')}}-{{item.endTime | formatDate('yyyy.MM.dd')}}</p>
            </div>
         </div>
         <div class="current-bill-box">
            <!-- 换电费用 -->
            <h2 class="current-bill-cost"><span>{{$t('bstext.bs22')}}</span><span class="ml5">{{billInfo.currencySymbol}}{{billInfo.battAmount | formatPrice}}</span></h2>
            <div class="current-bill-content">
               <!-- 本月付费换电量 -->
               <p class="current-bill-name mb0"><span class="en-break-all">{{$t('bstext.bs23')}}</span><i class="ml5">{{billInfo.dosage}}kWh</i></p>
            </div>
         </div>
         <!-- 0729 李鹏暂时去掉这个 不计算套餐变更费用 -->
         <div class="current-bill-box" v-if="false">
         <!-- <div class="current-bill-box" v-if="billInfo.exchangeAmount"> -->
            <!-- 变更费用 -->
            <h2 class="current-bill-cost"><span>{{$t('bstext.bs25')}}</span><span class="ml5">{{billInfo.currencySymbol}}{{billInfo.exchangeAmount | formatPrice}}</span></h2>
            <div class="current-bill-content">
               <!-- 升级费用 -->
               <p class="current-bill-name mb0"><span>{{$t('bstext.bs26')}}</span><i class="ml5">{{billInfo.currencySymbol}}{{billInfo.exchangeAmount | formatPrice}}</i></p>
            </div>
         </div>
         <!-- 暂时不要了-->
         <div class="cost-info" v-if="false">
            <!-- 资费说明 -->
            <h2>{{$t('bstext.bs29')}}:</h2>
            <!-- 账单费用=套餐费用+换电费用+变更费用 -->
            <p>{{$t('bstext.bs30')}}</p>
            <!-- 套餐费用=月套餐固定费用(不足一天按天折算) -->
            <p>{{$t('bstext.bs31')}}</p>
            <!-- 换电费用=周期内付费换电总安时*2元 -->
            <p>{{$t('bstext.bs32')}}</p>
            <!-- 变更费用=超3个月升级费用 -->
            <p>{{$t('bstext.bs33')}}</p>
         </div>
         <div class="pay-btn-box" v-if="currentIndex==1">
            <bs-button class="w100" @click="payBill">{{$t('bstext.bs34')}}</bs-button>
         </div>
      </div>
      <div class="no-bill-info" :class="{'flex1':!showBillInfo}" v-else>
         <span class="bs-icon-no-bill"></span>
         <p>{{$t('bstext.bs43')}}</p>
      </div>
   </div>
</template>

<script>
import entrance from '@/mixin/entrance'
export default {
   data () {
      return {
         billInfo:{},
         payStatuss:[],
         currentIndex:1,
         sta:'',//已出账开始时间
         end:'',//已出账结束时间
         unsta:'',//未出账开始时间
         showBillInfo:false,
         // account:false,//有没有已出账单
         // noAccount:false,//有没有未出账单
      }
   },
   mixins:[entrance],
   computed:{
      payStatus(){
         return this.$store.state.payStatus
      }
   },
   mounted() {
      //我的账单 
      document.title = this.$t('bstext.bs44')
      this.payStatuss=this.$t('bsstatus.payStatuss')
   },
   watch:{
      token:function(newToken,oldToken){
         if(newToken){
            this.getbillCurr()
            this.getbillUnsettle()
         }
      }
   },   
   methods: {
      accountTab(item){
         this.currentIndex=item
         if(this.currentIndex==1){
            this.getbillCurr()
         }else{
            this.getbillUnsettle()
         }
      },
      webgetToken(res){      
         this.token=JSON.parse(res).token
      },
      // 当前已出账账单
      getbillCurr(){
         this.$appApi.nativeLoading(true,'',0)
         let req ={}
         this.$server.getbillCurr(req).then(res=>{
            // this.$BsMessage({message:res})
            let info =res.data
            this.sta=res.data.sta
            this.end=res.data.end
            if(this.currentIndex===1){
               this.billInfo=info
               this.showBillInfo=this.sta?true:false               
            }
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      }, 
      // 当前未出账账单
      getbillUnsettle(){
         this.$appApi.nativeLoading(true,'',0)
         let req ={}
         this.$server.getbillUnsettle(req).then(res=>{
            // this.$BsMessage({message:res})
            let info =res.data
            this.unsta=res.data.unsta
            if(this.currentIndex==2){
               this.billInfo=info
               this.showBillInfo=this.unsta?true:false
            }
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      }, 
      payBill(){
         this.$store.commit('SET_FLAG',1)
         this.$router.push(`/bs/battswap/payway?ono=${this.billInfo.ono}`)
      }     
   }
}
</script>

<style lang='less' scoped>
.currennt-bill{
   background: #F7F8FA;
   min-height: 100vh;
   .current-bill-head{
      position: relative;
      // box-sizing: border-box;
      padding: 24px 20px;
      height: 80px;
      background: #21242C;
      // .current-bill-month{
      //    padding-left: 4px;
      //    font-size: 18px;
      //    font-weight: 500;
      //    color: #FFFFFF;
      //    line-height: 25px;
      // }
      .bill-box{
         padding-top: 10px;
         display: flex;
         justify-content: center;
         text-align: center;
         .account{
            // margin-right: 80px;
         }
         .account-bill{
            // color: #8F95A3;
            width: 80px;
            flex: 1;
            .account-title{
               height: 20px;
               font-size: 14px;
               color: #8F95A3;
               line-height: 20px;
               margin-bottom: 1px;
            }
            .account-time{
               height: 14px;
               font-size: 10px;
               color: #8F95A3;
               line-height: 14px;
            }
            .active{
               color: #FFFFFF;
            }
            .account-line{
               display: none;
               position: relative;
               height:12px;
               &::after{
                  position: absolute;
                  content: '';
                  left: 0;
                  right: 0;
                  bottom: 0;
                  top: 0;
                  margin: auto;
                  width: 40px;
                  height: 4px;
                  background: #2E68F6;
               }
            }
            .active-line{
               display: block;
            }
         }
         .no-account{
            color: #8F95A3;
            width: 80px;
         }
      }
      .current-bill-price{
         position: absolute;
         left: 20px;
         top: 84px;
         width: calc(100vw - 40px);
         box-sizing: border-box;
         padding: 16px 16px 24px;
         background: #2E68F6;
         border-radius: 2px;
         .current-bill-date{
            margin-bottom: 16px;
            font-size: 16px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 22px;
         }
         .current-bill-account{
            font-size: 32px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 32px;
            span{
               margin-right: 6px;
               font-size: 16px;
               line-height: 22px;
            }
         }
      }
   }
   .current-bill-body{
      padding: 92px 20px 20px;
      .current-bill-box{
         margin-bottom: 24px;
         .current-bill-cost{
            display: flex;
            justify-content: space-between;
            padding:0 12px 0 4px;
            margin-bottom: 12px;
            font-weight: 600;
            color: #21242C;
            line-height: 22px;
            span{
               font-size: 16px;
            }
         }
         .current-bill-content{
            background: #FFFFFF;
            border-radius: 2px;
            padding: 12px;
            margin-bottom: 8px;
            .current-bill-name{
               display: flex;
               justify-content: space-between;
               color: #21242C;
               line-height: 20px;
               margin-bottom: 8px;
            }
            .current-bill-cycle{
               color: #8F95A3;
               line-height: 20px;
            }
            .mb0{
               margin-bottom: 0;
            }
         }
      }
      .cost-info{
         font-size: 14px;
         color: #8F95A3;
         line-height: 20px;
         padding: 0 4px;
         h2{
            margin-bottom: 8px;
            font-weight: normal;
         }
      }
      .pay-btn-box{
         margin: 32px 20px 20px;
      }
   }
   .no-bill-info{
      margin-top: 51.2vw;
      text-align: center;
      background: #F7F8FA;
      p{
         font-size: 14px;
         color: #8C92A0;
         line-height: 14px;
         margin-top: 16px;
      }
   }
   .flex1{
      flex: 1;
   }
}
.flex-column{
   display: flex;
   flex-direction: column;
}
</style>


// WEBPACK FOOTER //
// src/components/blueshark/battswap/mybill/currentbill.vue